const fontFamily = {
    headers: 'Roboto',
    paragraph: '',
    label: 'Inter',
    buttons: 'Inter',
    textField: 'Inter',
    link: '',
};

export default fontFamily;